import { useEffect, useRef } from "preact/hooks";
import assets, { getDay } from "../assets";
import GRID from "../components/GRID";
import { achievement } from "../utils";

export const BackToAtrium = {
    height: "7.3%",
    label: "Back to Atrium",
    href:"/atrium",
    left: "42.9%",
    top: "89.7%",
    width: "13%"
}

export default () => {
    const day = getDay()

    return {
        background: assets.breakouts.df,
        links: [
            BackToAtrium,
            {
                height: "37.2%",
                href: day > 0 ? "/breakout-one" : undefined,
                label: "Breakouts Day One",
                left: "15%",
                top: "16%",
                width: "27%",
                modalOverrides: {
                    dismissHTML: "X"
                },
                modal: day === 0 ? <div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
                    <h1 style="font-size: 28px; margin: 0;">Content locked</h1>
                    <p style="font-size: 16px;">
                        <p>These On Demand Breakouts sessions will be available starting October 27th</p>
                    </p>
                </div> : undefined
            },
            {
                height: "37.2%",
                href: day > 1 ? "/breakout-two" : undefined,
                label: "Breakouts Day Two",
                left: "59%",
                top: "16%",
                width: "27%",
                modalOverrides: {
                    dismissHTML: "X"
                },
                modal: day < 2 ? <div style="display: flex; flex-direction: column; justify-content: space-around; width: 600px; height: 130px; color: white;">
                    <h1 style="font-size: 28px; margin: 0;">Content locked</h1>
                    <p style="font-size: 16px;">
                        <p>These On Demand Breakouts sessions will be available starting October 28th</p>
                    </p>
                </div> : undefined
            },
        ],
        name: "breakouts",
        showNavbar: false
    }
}

export const BreakoutOne = {
    background: assets.breakouts_one.df,
    links: [BackToAtrium],
    showNavbar: false,
    name: "breakout-one",
    extras: <>
        <GRID 
            {...assets.breakouts_one.GRID} 
            isModal 
            roomName="breakout-one" 
            modalContent={(link) => () => {
                const ref = useRef(null)
                const triggered = useRef(false)

                useEffect(() => {
                    const player = new Vimeo.Player(ref.current)
                    player.on("timeupdate", it => {
                        if (it.percent <= .95 || triggered.current || day < 3) return;
                        achievement(link[2])
                        triggered.current = true
                    })
                }, [])

                return <iframe ref={ref} src={link[1]} allow="autoplay" style={{
                    border: 0,
                    borderRadius: "16px",
                    width: "66em",
                    marginTop: "22px",
                    aspectRatio: "16/9"
                }} />
            }}   
        />
    </>,
    active: assets.isOnDemand()
}

export const BreakoutTwo = () => { 
    
    const day = getDay()
    const breakout = assets.breakouts_two

    const gridList = breakout.GRID
    const background = day < 3 ? breakout.df[0] : breakout.df[1]

    return {
        background,
        links: [BackToAtrium],
        extras: <>
            { gridList.map((grid, idx) => <GRID 
                    {...grid} 
                    isModal 
                    roomName="breakout-two" 
                    modalContent={(link) => () => {
                        
                        const ref = useRef(null)
                        const triggered = useRef(false)

                        useEffect(() => {
                            const player = new Vimeo.Player(ref.current)
                            player.on("timeupdate", it => {
                                if ((idx == 0 && day < 2) || (idx != 0 && day < 3)) return;
                                if (it.percent <= .95 || triggered.current || day < 2) return;
                                achievement(link[2])
                                triggered.current = true
                            })
                        }, [])

                        return <iframe ref={ref} src={link[1]} allow="autoplay" style={{
                            border: 0,
                            borderRadius: "16px",
                            width: "66em",
                            marginTop: "22px",
                            aspectRatio: "16/9"
                        }} />
                    }}    
                />)
            }
        </>,
        name: "breakout-two",
        active: assets.isOnDemand(),
        showNavbar: false
    }
}